import {WalletContext} from '#/contexts/wallet-provider';
import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {useQuery} from '@tanstack/react-query';
import {useContext} from 'react';
import {getBalance} from 'viem/actions';

export const useNativeTokenBalance = () => {
  const {
    accountResult: {address},
    publicClient,
  } = useContext(WalletContext);

  const {data: balance, ...rest} = useQuery({
    queryKey: [baseKeysUseQuery.useNativeTokenBalance, address],
    queryFn: () => getBalance(publicClient!, {address: address!}),
    enabled: !!address && !!publicClient,
  });

  return {
    data: balance ?? -1n,
    ...rest,
  };
};
